import { render } from "./Inventory.vue?vue&type=template&id=6bca8a22"
import script from "./Inventory.vue?vue&type=script&lang=ts"
export * from "./Inventory.vue?vue&type=script&lang=ts"
script.render = render

export default script